import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@craft/shared'
import { questions } from '../data/questions'
import Logo from '../components/Logo'
import AuthModal from '../components/AuthModal'

const DIFFICULTY_COLORS = {
  基礎: { bg: '#22C55E22', color: '#4ADE80', border: '#22C55E44' },
  標準: { bg: '#14B8A622', color: '#5EEAD4', border: '#14B8A644' },
  応用: { bg: '#8B5CF622', color: '#C4B5FD', border: '#8B5CF644' },
}

export default function QuestionsPage() {
  const navigate = useNavigate()
  const { user, userData } = useAuth()
  const [showAuth, setShowAuth] = useState(false)

  const completed = userData?.completedChem || []

  const openQuestion = (q) => {
    // isFree(id<=3) は誰でも、それ以外はログイン必須
    if (!q.isFree && !user) {
      setShowAuth(true)
      return
    }
    navigate(`/learn/${q.id}`)
  }

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(180deg, #0a0e1a 0%, #111827 100%)', fontFamily: "'Noto Sans JP', sans-serif" }}>
      <header className="flex items-center justify-between px-4 md:px-8 py-4 border-b border-white/10">
        <div className="flex items-center gap-4">
          <button onClick={() => navigate('/')} className="text-white/60 hover:text-white text-sm">← ホーム</button>
          <Logo size="sm" />
        </div>
        {user ? (
          <span className="text-xs text-white/50">{user.email}</span>
        ) : (
          <button onClick={() => setShowAuth(true)}
            className="text-xs px-4 py-2 rounded-lg font-bold text-white"
            style={{ background: 'linear-gradient(135deg, #34D399, #14B8A6)' }}>
            ログイン
          </button>
        )}
      </header>

      <div className="max-w-5xl mx-auto px-4 md:px-8 py-8">
        <h1 className="text-2xl md:text-3xl font-black text-white mb-1">問題一覧</h1>
        <p className="text-white/50 text-sm mb-6">
          構造式を組み立てて採点。共通テストの化学で問われる分子を収録しています。
          {!user && '（Q1〜3は登録不要でお試しできます）'}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {questions.map((q) => {
            const d = DIFFICULTY_COLORS[q.difficulty] || DIFFICULTY_COLORS['標準']
            const isDone = completed.includes(q.id)
            const locked = !q.isFree && !user
            return (
              <button key={q.id} onClick={() => openQuestion(q)}
                className="text-left p-4 rounded-xl transition-all hover:scale-[1.02] relative"
                style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)' }}>
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs font-bold text-white/40">Q{q.id}</span>
                  <div className="flex items-center gap-1.5">
                    {isDone && (
                      <span className="text-[10px] px-2 py-0.5 rounded-full font-bold"
                        style={{ background: '#22C55E22', color: '#4ADE80' }}>✓ 完了</span>
                    )}
                    <span className="text-[10px] px-2 py-0.5 rounded-full font-bold"
                      style={{ background: d.bg, color: d.color, border: `1px solid ${d.border}` }}>
                      {q.difficulty}
                    </span>
                  </div>
                </div>
                <h3 className="text-base font-bold text-white mb-1">{q.title}</h3>
                <p className="text-xs text-white/45">{q.category}・{q.formula}</p>
                {locked && (
                  <div className="absolute inset-0 rounded-xl flex items-center justify-center"
                    style={{ background: 'rgba(10,14,26,0.72)', backdropFilter: 'blur(1px)' }}>
                    <span className="text-xs font-bold text-white/80">🔒 ログインで解放</span>
                  </div>
                )}
              </button>
            )
          })}
        </div>
      </div>

      {showAuth && <AuthModal onClose={() => setShowAuth(false)} onSuccess={() => setShowAuth(false)} />}
    </div>
  )
}
